import { Link } from 'react-router-dom';

export default function ServicesPreview() {
  const services = [
    {
      title: '舊屋改造',
      description: '結構更新、格局優化、水電重整，讓舊屋安全舒適',
      image: 'https://public.readdy.ai/ai/img_res/65962927101ec2a2efd0cd73d1fb7a24.jpg',
      link: '/services#old-house',
    },
    {
      title: '浴室改造',
      description: '打除重作、防水更新、設備換新，提升生活品質與房屋價值',
      image: 'https://readdy.ai/api/search-image?query=modern%20bathroom%20renovation%20clean%20white%20tiles%20glass%20shower%20enclosure%20contemporary%20fixtures%20bright%20lighting%20minimalist%20design%20hotel%20style%20bathroom%20elegant%20vanity%20mirror%20quality%20materials%20taiwanese%20residential%20bathroom%20professional%20renovation%20work%20luxurious%20feel%20practical%20layout&width=600&height=800&seq=service-002&orientation=portrait',
      link: '/services#bathroom',
    },
    {
      title: '室內裝修統包',
      description: '設計、施工、監工一次完成，減少溝通成本',
      image: 'https://readdy.ai/api/search-image?query=complete%20interior%20renovation%20project%20construction%20site%20professional%20contractors%20working%20modern%20residential%20space%20organized%20workspace%20quality%20materials%20systematic%20approach%20taiwanese%20home%20renovation%20comprehensive%20service%20efficient%20workflow%20attention%20to%20detail%20clean%20construction%20environment&width=600&height=800&seq=service-003&orientation=portrait',
      link: '/services#turnkey',
    },
    {
      title: '居家軟裝設計',
      description: '家具、燈具、窗簾、家飾佈置，讓裝修後直接入住',
      image: 'https://readdy.ai/api/search-image?query=home%20soft%20furnishing%20interior%20styling%20modern%20furniture%20arrangement%20cozy%20living%20room%20warm%20lighting%20decorative%20cushions%20curtains%20plants%20elegant%20accessories%20comfortable%20sofa%20coffee%20table%20minimalist%20decor%20inviting%20atmosphere%20professional%20interior%20design%20move%20in%20ready%20home&width=600&height=800&seq=service-004&orientation=portrait',
      link: '/services#soft-decoration',
    },
  ];

  return (
    <section className="py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-12">
          <span className="text-sm font-light text-[#1E4D7B] uppercase tracking-wider">我們的服務</span>
          <h2 className="text-5xl lg:text-6xl font-bold text-primary mt-3 mb-4 font-serif">
            專注於讓家<br />真正完成
          </h2>
          <p className="text-base text-gray-600">從設計到入住，一站式整合服務</p>
        </div>

        <div className="relative">
          <div className="flex gap-8 overflow-x-auto pb-8 snap-x snap-mandatory scrollbar-hide">
            {services.map((service, index) => (
              <a
                key={index}
                href={service.link}
                className="flex-shrink-0 w-80 bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-300 snap-start group cursor-pointer"
              >
                <div className="relative h-96 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-white via-white/20 to-transparent"></div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6">
                    {service.description}
                  </p>
                  <div className="flex items-center justify-end">
                    <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white group-hover:bg-[#4A90C2] transition-colors">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </div>
              </a>
            ))}
            <div className="flex-shrink-0 w-20"></div>
          </div>
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-full text-base font-medium hover:bg-primary/90 transition-all whitespace-nowrap"
          >
            查看所有服務
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}